import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import SeoPage from "@/pages/SeoPage";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import LegalPage from "@/pages/LegalPage";
import CookieConsent from "@/components/CookieConsent";

function ScrollManager() {
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (location.hash) {
      const scroll = () => {
        const el = document.querySelector(location.hash);
        if (el) {
          if (lenis) lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      };
      const timer = setTimeout(scroll, 120);
      return () => clearTimeout(timer);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash, lenis]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollManager />
          <div className="App">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/impressum" element={<LegalPage docKey="impressum" />} />
              <Route path="/datenschutz" element={<LegalPage docKey="datenschutz" />} />
              <Route path="/:slug" element={<SeoPage />} />
              <Route path="*" element={<Landing />} />
            </Routes>
            <Toaster
              position="bottom-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#121212",
                  border: "1px solid rgba(57,255,20,0.4)",
                  color: "#fff",
                },
              }}
            />
            <CookieConsent />
          </div>
        </BrowserRouter>
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
